import React from "react";

export default function InvoiceView({ data }) {
  if (!data) return null;

  return (
    <>
      {/* Header */}
      <div className="w-full text-left p-3 flex items-center gap-3 bg-[#5a6db3] ">
        <h2 className="text-lg font-semibold">Invoice Details</h2>
      </div>

      {/* Seller + Buyer */}
      <div className="border border-t-0 rounded-b-lg p-4 grid grid-cols-2 gap-6 bg-white shadow">
        <div>
          <h3 className="font-semibold mb-2">Seller Information</h3>
          <p><b>Seller:</b> {data.seller_name || "N/A"}</p>
          <p><b>Address:</b> {data.seller_address || "N/A"}</p>
          <p><b>Contact:</b> {data.seller_contact || "N/A"}</p>
        </div>

        <div>
          <h3 className="font-semibold mb-2">Buyer & Invoice</h3>
          <p><b>Buyer:</b> {data.buyer_name || "N/A"}</p>
          <p><b>Address:</b> {data.buyer_address || "N/A"}</p>
          <p><b>Invoice #:</b> {data.invoice_number || "N/A"}</p>
          <p><b>Invoice Date:</b> {data.invoice_date || "N/A"}</p>
          <p><b>Due Date:</b> {data.due_date || "N/A"}</p>
          <p><b>Currency:</b> {data.currency || "N/A"}</p>
        </div>
      </div>

      {/* Totals */}
      <div className="mt-4 p-3 border bg-white rounded-lg flex justify-between">
        <p><b>Sub Total:</b> {data.subtotal || "0"}</p>
        <p><b>Tax Amount:</b> {data.tax_amount || "0"}</p>
        <p><b>Grand Total:</b> {data.grand_total || "0"}</p>
      </div>

      {/* Line Items */}
      <div className="border bg-white shadow mt-6">
        <h3 className="w-full text-left p-3 bg-[#5a6db3] ">
          Line Items
        </h3>

        <div className="overflow-x-auto">
          <table className="w-full border rounded-lg overflow-hidden">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 border">Description</th>
                <th className="px-4 py-2 border">Quantity</th>
                <th className="px-4 py-2 border">Unit Price</th>
                <th className="px-4 py-2 border">Total Price</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(data.items) && data.items.length > 0 ? (
                data.items.map((item) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border">{item.description}</td>
                    <td className="px-4 py-2 border">{item.quantity}</td>
                    <td className="px-4 py-2 border">{item.unit_price}</td>
                    <td className="px-4 py-2 border">{item.total_price}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center py-3 border">
                    No line items found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
